module.exports = "/_next/static/images/5f2d921b7473afbfbc28eeb6c4c4efdf-young-people-walking@0.75x.jpg.webp";